<template>
  <span>
    <div id="family-of-brands-section">
      <h3 class="headline text-center col-12 pt-5 pb-3">
        Proud Member of the PulteGroup Family of Companies
      </h3>
      <div class="container-fluid text-md-center pb-4">
        <div class="brand-grid">
          <div class="brand-item">
            <a href="https://www.pulte.com/" target="_blank">
              <img
                src="../assets/images/logos/Logo-PulteHomes.png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="https://www.delwebb.com/" target="_blank">
              <img
                src="../assets/images/logos/Logo-DelWebb-4C-trans.png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="https://www.divosta.com/" target="_blank">
              <img
                src="../assets/images/logos/Logo-DiVosta-4C-trans.png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="https://www.centex.com/" target="_blank">
              <img
                src="../assets/images/logos/Logo-Centex-4C-trans.png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="https://www.jwhomes.com/" target="_blank">
              <img
                src="../assets/images/logos/Logo-John-Weiland-4C-trans.png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="http://www.pgptitle.com/">
              <img
                src="../assets/images/logos/2025/PGPTitle_Logo_White (horizontal).png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="http://www.pulteinsuranceagency.com/" target="_blank">
              <img
                src="../assets/images/logos/2025/PulteInsuranceAgency_Logo_White  (horizontal).png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
          <div class="brand-item">
            <a href="https://login.pultemortgage.com/" target="_blank">
              <img
                src="../assets/images/logos/2025/PulteMortgage_Logo_White (horizontal).png"
                class="fbimg img-fluid"
              />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid text-md-center" id="footerlinks">
      <div class="row">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4">
          <ul class="links">
            <li class="footer-section-title">Site Links</li>
            <li class="">
              <router-link to="/" class="listitem router-link-active"
                >Home</router-link
              >
            </li>
            <li class="">
              <router-link to="/Alta" class="listitem router-link-active"
                >ALTA Best Practices</router-link
              >
            </li>
            <li class="">
              <router-link
                to="/CompanyInformation"
                class="listitem router-link-active"
                >Company Information
              </router-link>
            </li>
            <li class="">
              <router-link to="/Leadership" class="listitem router-link-active"
                >Leadership</router-link
              >
            </li>
            <li class="">
              <router-link to="/ContactUs" class="listitem router-link-active"
                >Contact Us</router-link
              >
            </li>
            <li class="">
              <router-link
                to="/PrivacyPolicy"
                class="listitem router-link-active"
                >Privacy Policy</router-link
              >
            </li>
          </ul>
        </div>
        <div class="col-12 col-sm-4 col-md-4 col-lg-4">
          <ul class="links">
            <li class="footer-section-title">Family of Companies</li>
            <li>
              <a href="https://www.pulte.com/" target="_blank" class="listitem"
                >Pulte Homes</a
              >
            </li>
            <li>
              <a
                href="https://www.delwebb.com/"
                target="_blank"
                class="listitem"
                >Del Webb</a
              >
            </li>
            <li>
              <a
                href="https://www.divosta.com/"
                target="_blank"
                class="listitem"
                >DiVosta</a
              >
            </li>
            <li>
              <a href="https://www.centex.com/" target="_blank" class="listitem"
                >Centex</a
              >
            </li>
            <li>
              <a
                href="https://www.jwhomes.com/"
                target="_blank"
                class="listitem"
                >John Wieland</a
              >
            </li>
            <li>
              <a href="http://www.pgptitle.com/" class="listitem">PGP Title</a>
            </li>
            <li>
              <a
                href="https://www.pultemortgage.com/"
                target="_blank"
                class="listitem"
                >Pulte Mortgage</a
              >
            </li>
            <li>
              <a
                href="http://www.pulteinsuranceagency.com/"
                target="_blank"
                class="listitem"
                >Pulte Insurance</a
              >
            </li>
            <!---->
            <li class="careers">
              <a
                href="https://pultegroup.wd1.myworkdayjobs.com/PGI"
                target="_blank"
                class="listitem"
                >Careers – External Candidates</a
              >
            </li>
            <li class="careers">
              <a
                href="https://www.myworkday.com/pultegroup/d/task/3005$4482.htmld"
                target="_blank"
                class="listitem"
                >Careers – Current Employees</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container-fluid text-md-center p-4" id="disclaimerlinks">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-start">
          PGP Title is authorized and licensed to do the business of insurance
          in the states of: Arizona, Colorado, Florida, Georgia, Illinois,
          Indiana, Kentucky, Maryland, Michigan, Minnesota, Missouri, Nevada,
          New Jersey, New Mexico, North Carolina, Ohio, Pennsylvania, South
          Carolina, Texas and Virginia. <br />
          <div class="pt-3">
            © Copyright {{ new Date().getFullYear() }} PGP Title. All Rights
            Reserved.
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-6 col-lg-6 text-end">
          <a href="https://www.pulte.com/terms-of-use">Terms of Use</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<router-link to="PrivacyPolicy"
            >Privacy Policy</router-link
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a
            href="https://www.pulte.com/equal-house-opportunity"
            >Equal Housing Opportunity</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<router-link to="ContactUs" class=""
            >Contact Us</router-link
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a
            href="http://www.pultegroup.com/careersite"
            >Careers</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a
            href="http://www.pultegroupinc.com/investor-relations/press-releases/default.aspx"
            >Press Room</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a
            href="http://www.pultegroupinc.com/investor-relations/press-releases/default.aspx"
            >Investor Relations</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a href="https://www.pulte.com/suppliers"
            >Suppliers</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a
            href="https://www.pulte.com/internet-based-ads"
            >Internet Based Ads</a
          >&nbsp;&nbsp; | &nbsp;&nbsp;<a href="https://www.pulte.com/sitemap"
            >Sitemap</a
          >
        </div>
      </div>
    </div>
  </span>
</template>

<style scoped>
a {
  text-align: center;
}

h3.headline {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  margin: 0 0 8px;
  color: #fff;
  padding: 48px 15px 16px;
}

div#family-of-brands-section {
  background-color: #003c5b;
}

.fbimg {
  width: 60%;
  max-width: 125px;
  padding-bottom: 10px;
}

.brand-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.brand-item {
  flex: 0 0 25%;
  max-width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
}

.brand-item .fbimg {
  width: 95%;
}

@media (max-width: 991px) {
  .brand-item {
    flex: 0 0 50%;
    max-width: 50%;
  }
}

div.flex {
  text-align: center;
}

div#footerlinks {
  color: #fff;
  font-size: 16px;
  background-color: #414a4e;
  padding: 60px 0px 60px 30px;
}

div#disclaimerlinks {
  background-color: rgb(32, 42, 47);
  font-size: 14px;
  font-weight: 400;
  color: #fff;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
}

ul {
  list-style-type: none;
  text-align: left;
  padding: 20px 0 20px 30px;
}

li.footer-section-title {
  color: #fff;
  font-weight: 700;
}

li {
  margin: 0 0 4px;
}

a {
  color: #fff;
  font-family: Source Sans Pro, Arial, Helvetica, sans-serif;
  font-weight: 400;
  line-height: 24px;
  text-decoration-line: none;
}

/* fix for padding on bottom of logos */
#family-of-brands-section > div > div > div > a > img {
  padding-bottom: 0;
}
</style>

<script setup></script>
